import { render, staticRenderFns } from "./DLApprove.vue?vue&type=template&id=f508df58&"
import script from "./DLApprove.vue?vue&type=script&lang=js&"
export * from "./DLApprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports